import React, { useEffect, useState, useContext } from 'react';
import { getCompetitorGamesById } from '@home/services/competitor';
import Loading from '@/pages/dashboard/components/Loadings';
import StudioCompetitor from '@intelligence/pages/TopCharts/PCConsoleGames/StudioCompetitor';
import { StudioContext } from '@home/pages/studio/context';
import { CompetitorGame, TypeIdList } from '../../type';
import { buriedPointGame } from "@/pages/home/utils/buriedPoint";
import { PageLogMes } from '@home/utils/buriedPointCfg';
import { getExtendInfoInLog } from '@home/pages/studio/utils';
import StudioState from '@home/pages/studio/components/StudioState';
import { useIntl } from 'umi';
import { JumpType } from '@home/utils/utils';

// 默认选择5款竞品+本游戏
export const DEFAULT_GAME_SELECT_NUM = 6;

export default function PcCompetitor() {
  const { currentGame, menuPermission, studioInfo } = useContext(StudioContext);
  const { unified_edition_id: gameid, studio_code: studioid, game_type: gameType } = currentGame || {};
  const focusGenre = studioInfo?.studio_info?.focus_genre || '';
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { formatMessage } = useIntl(); // 中英切换方法
  const [filterCardLoading, setFilterCardLoading] = useState(true);
  const [currentVersionGameID, setCurrentVersionGameID] = useState<string>('');
  const [defaultSelection, setDefaultSelection] = useState<CompetitorGame[]>([]);
  // 初始化为本游戏id，避免获取竞品失败
  const [defaultSelectionIds, setDefaultSelectionIds] = useState<string[]>([]);
  const controller = new AbortController();
  const shortcutList = focusGenre ? focusGenre?.split(',')?.map((genre: string) => ({
    text: genre.trim(),
    value: genre.trim(),
    name: genre.trim(),
  })) : [];
  const getCompetitorGameList = async (gameid: string, entityType: string) => {
    // 调用竞品游戏，默认的5款，用于给筛选器赋初始值
    setFilterCardLoading(true);
    try {
      if (!gameid) {
        throw new Error();
      }

      const resData = await getCompetitorGamesById({
        entity_type: entityType,
        game_id: gameid,
        top_n: DEFAULT_GAME_SELECT_NUM - 1,
      }, { signal: controller.signal });
      const checkedList = resData?.data?.game_list?.slice(0, DEFAULT_GAME_SELECT_NUM) || [];
      // 本游戏为PC版本，要找出Combine版本作为本游戏高亮id
      const currentGame = checkedList?.find((item: CompetitorGame) => {
        const typeIdList = item?.typeIdList || [];
        return typeIdList?.some((typeId: TypeIdList) => typeId?.type === entityType && typeId?.id === gameid);
      });

      if (!checkedList.length || !currentGame?.id) {
        throw new Error('接口没有竞品游戏返回！或接口没找到本游戏对应的combine版本！');
      }
      setCurrentVersionGameID(currentGame?.id);
      setDefaultSelection(checkedList);
      setDefaultSelectionIds(checkedList.map((t: CompetitorGame) => t?.id));
      setFilterCardLoading(false);
    } catch (err: unknown) {
      // @ts-ignore
      if (err?.msg === 'canceled') {
        // 如果是被取消，则恢复为初始态
        setFilterCardLoading(true);
      } else {
        setFilterCardLoading(false);
      }
      catchErr();
    }
  };

  const catchErr = () => {
    // 接口报错时给默认为本游戏id请求接口，否则为空字符串，返回无数据
    setCurrentVersionGameID('');
    setDefaultSelection([]);
    setDefaultSelectionIds([]);
  };

  useEffect(() => {
    getCompetitorGameList(gameid, gameType);
    buriedPointGame({gameName: currentGame?.game_name, ...PageLogMes.studioCompetitors}, gameid, 'unified_id');
    return () => {
      controller.abort('页面离开，cancel调用');
      // 销毁后更新为初始态
      setFilterCardLoading(true);
    };
  }, [gameid, studioid, gameType, currentGame]);
  console.log('menuPermission',menuPermission, currentVersionGameID)
  if (menuPermission === false) {
    return <StudioState isNoPermission={true} />;
  }
  return filterCardLoading ? (
    <Loading />
  ) : currentVersionGameID ? (<>
    {/* <div className='dbh-studio-competitor-title'>
      {formatMessage({ id: 'dbh_competitor' })}
    </div> */}
      <StudioCompetitor
        key={gameid}
        defaultSelectionIds={defaultSelectionIds}
        defaultSelection={defaultSelection}
        gameHightList={currentVersionGameID ? [currentVersionGameID] : []}
        pageLogMes={getExtendInfoInLog(PageLogMes.studioCompetitors, gameid)}
        shortcutList={shortcutList}
        config={{jumpType: JumpType.Window}}
      />
  </>
  ) : <StudioState />;
}
